module.exports = __webpack_public_path__ + "static/img/zCity.9dcac96e.png";